import { c as _c } from "react/compiler-runtime";
import type { AuditEventDetail } from '@onefootprint/request-types/dashboard';
import capitalize from 'lodash/capitalize';
import { useTranslation } from 'react-i18next';
import ApiKeyDisplay from '../api-key-display';
type UpdateOrgApiKeyStatusProps = {
  detail: AuditEventDetail;
  hasPrincipalActor: boolean;
};
const UpdateOrgApiKeyStatus = t0 => {
  const $ = _c(16);
  const {
    detail,
    hasPrincipalActor
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "events.userData"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("security-logs", t1);
  if (detail.kind !== "update_org_api_key_status") {
    return null;
  }
  const {
    apiKey: t2,
    status
  } = detail.data;
  const {
    name,
    role: t3
  } = t2;
  const {
    scopes,
    name: roleName
  } = t3;
  let t4;
  let t5;
  if ($[1] !== hasPrincipalActor || $[2] !== status || $[3] !== t) {
    const statusText = status === "enabled" ? t(_temp) : t(_temp2);
    t4 = "text-body-2 text-tertiary";
    t5 = hasPrincipalActor ? statusText : capitalize(statusText);
    $[1] = hasPrincipalActor;
    $[2] = status;
    $[3] = t;
    $[4] = t4;
    $[5] = t5;
  } else {
    t4 = $[4];
    t5 = $[5];
  }
  let t6;
  if ($[6] !== t4 || $[7] !== t5) {
    t6 = <span className={t4}>{t5}</span>;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== name || $[10] !== roleName || $[11] !== scopes) {
    t7 = <ApiKeyDisplay name={name} scopes={scopes} roleName={roleName} />;
    $[9] = name;
    $[10] = roleName;
    $[11] = scopes;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  return t8;
};
export default UpdateOrgApiKeyStatus;
function _temp($) {
  return $.enabled;
}
function _temp2($_0) {
  return $_0.disabled;
}